export const Statuses = {
  default: '#bebfc0',
  early: '#a5ccec',
  late: '#8447f6',
  unassigned: '#bebfc0',
  pending: '#fa6725',
  in_progress: '#fbc04f',
  succeeded: '#66b752',
  failed: '#d63031',
};

const styles = {
  container: {
    height: '100%',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
  },
  title: {
    display: 'flex',
    fontSize: '12px',
    fontWeight: 'normal',
    color: '#4a4a4a',
    textAlign: 'left',
    padding: '12px',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontFamily: 'AvenirNext-Bold',
  },
  innerTitle: {
    flex: 1,
    textAlign: 'center',
  },
  info: {
    fontSize: '12px',
    color: '#e4e4e4',
    marginBottom: '4px',
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  shipmentTotal: {
    fontSize: '16px',
    color: '#3b3b3b',
    display: 'inline-block',
    margin: '0 5px',
  },
  chart: {
    display: 'flex',
    flex: 1,
  },
  pane: {
    width: '50%',
    padding: '15px',
    boxSizing: 'border-box',
  },
  panelContainer: {
    flex: 1,
  },
  innerPanelContainer: {
    flex: 1,
    padding: '0 15px 10px',
    textAlign: 'left',
  },
  rowTitle: {
    fontSize: '13px',
    fontWeight: 'bold',
    width: '275px',
    margin: '0 auto 5px',
  },
  rowLabel: {
    display: 'inline-block',
    width: '135px',
    fontSize: '12px',
    color: '#888',
    textAlign: 'right',
    marginRight: '10px',
    fontWeight: 'normal',
  },
  toggleButton: {
    flex: 0,
    marginRight: '15px',
  },
  toggleChartLink: {
    fontFamily: 'AvenirNext',
    fontSize: '12px',
    color: '#4a90e2',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontWeight: 'normal',
    border: 'none',
    background: 'none',
  },
  dateTitle: {
    fontFamily: 'AvenirNext-MediumItalic',
    fontSize: '11px',
    padding: '0 5px',
  },
};

export default styles;
